/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import { EditorState } from 'prosemirror-state'
import { findParentNodeOfType } from 'prosemirror-utils'
import { TableIcon } from '@tinacms/icons'

import { commandControl } from '../../../components/MenuHelpers'
import { insertTable } from '../commands'

function insertTableCmd(state: EditorState, dispatch: any) {
  const { table, code_block } = state.schema.nodes
  const { selection } = state
  const currentNode = selection.$to.node(selection.$to.depth)
  if (currentNode && currentNode.type === code_block) return false
  const tableParent = findParentNodeOfType(table)(selection)
  if (tableParent) return false
  return insertTable(state, dispatch)
}

export const ProsemirrorMenu = commandControl(
  insertTableCmd,
  TableIcon,
  'Table',
  'Table'
)
